export default {
  methods: {
    sortByDate (items, type, first = 1, second = -1) {
      return items.sort((a, b) => {
        if (a[type] > b[type]) return first
        if (a[type] < b[type]) return second
        return 0
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/sortByDate.js